import { BlockError } from '@/blocks.04-project/block-error/block-error';
import { LazyInit } from '@/blocks.04-project/lazy-init/lazy-init';
import isNull from 'lodash-es/isNull.js';

/***
 * Класс для кастомного скролла
 *
 * !!Важно!! После добавление класса обязательно проверить корректное отображение стилей с библиотекой, так как она создаёт много обёрток над контентом
 *
 * @example
 * supportCustomScrollBar {null/boolean} - хранит значение для проверки поддержки скролла
 */
class CustomScrollbar {
	/***
	 * Конструктор класса
	 * @param elem {HTMLElement} DOM элемент с классом custom-scrollbar
   * @param force {Boolean} принудительно инициализирование
	 */
  constructor(elem, force) {
		this.BlockError = new BlockError({ blockName: 'CustomScrollbar', destroy: this.destroy });

		if (!elem) return this.BlockError.error('Отсутствует elem');
    this.block = elem;
    this.block.CustomScrollbar = this;
    this.block.AsyncCustomScrollbar = new Promise((resolve) => {
      this.promiseResolve = resolve;
    }).then((ins) => ins);

    this.LazyInit = new LazyInit({ ins: this, callback: this.init, addClass: 'custom-scrollbar_inited' });
    this.LazyInit.init();
    if (force) this.LazyInit.earlyInit();
  }

  init = async () => {
		const { default: SimpleBar } = await import(/* webpackChunkName: "Simplebar" */ 'simplebar').catch((err) => {
			throw new Error(err);
		});

		this.scrollbar = new SimpleBar(this.block, {
			autoHide: false,
		});

    this.promiseResolve(this);
    this.block.AsyncCustomScrollbar = this;
  };

  destroy = () => {
		if (this.scrollbar) {
			this.scrollbar.unMount();
			const content = this.block.querySelector('.simplebar-content');
			if (content) this.block.firstChild.replaceWith(...content.childNodes);
		}
		if (this.block) {
			delete this.block.dataset['simplebar'];
			this.block.classList.remove('custom-scrollbar_inited');
			delete this.block.CustomScrollbar;
      delete this.block.AsyncCustomScrollbar;
		}
  };

	static checkCustomScrollBar() {
		if (!isNull(CustomScrollbar.supportCustomScrollBar)) return CustomScrollbar.supportCustomScrollBar;
		document.body.insertAdjacentHTML('beforeend', `
      <div id="CustomScrollBar">
        <style>
        #CustomScrollBar { width: 99px; height: 99px; overflow: scroll; position: absolute; top: -999px }
        #CustomScrollBar::-webkit-scrollbar{ width: 40px }
        </style>
      </div>`);
		const elem = document.getElementById('CustomScrollBar');
		const result = (elem.offsetWidth - elem.clientWidth) === 40;
		elem.remove();
		CustomScrollbar.supportCustomScrollBar = result;
		return result;
	}

	static supportCustomScrollBar = null;

	/**
	 * @param container {HTMLElement|Document}
	 * @param force{Boolean}
	 */
  static init(container = document, force = false) {
		if (!CustomScrollbar.checkCustomScrollBar()) {
			Array.from(container.querySelectorAll('.custom-scrollbar:not(.custom-scrollbar_inited)')).forEach((elem) => new CustomScrollbar(elem, force));
		}
  }
}

document.addEventListener('DOMContentLoaded', () => CustomScrollbar.init());

// Экспорт;
window.Block.CustomScrollbar = CustomScrollbar;
